// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomWidgetCategoryView__wrapper___XsBZX CategoryView__categoryView___61-Ot"};